var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loader-wrapper w-full h-full"},[_c('div',{staticClass:"flex h-full items-center justify-center flex-col"},[_c('div',{staticClass:"text-gray-400 text-sm pb-4"},[_vm._v(_vm._s(_vm.$t('no_data'))+". "+_vm._s(_vm.$t('unexpected')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }